// ═══ 말소대행신청 순수 로직 (B3 S2) — 앱 malso_quick_request.dart · malso_request_controller.dart 와 같은 규칙 ═══
// 화면 상태·호출 없음. POST /cancel-requests/quick body 는 **키 존재 규칙**이 계약의 핵심(서버 ownKey) —
// 공통 옵션을 쓰는 차에는 services·buyerName 키를 넣지 않는다. agencyId·companyId 는 보내지 않는다(서버 결정).
// 말소 화면 모드는 차량번호만 받는다(Jin 11/04) — body 첫 키 carNoOnly:true, 서류는 업체가 준비(서버가 말소신청서를 만들지 않음).

function str(v) { return String(v == null ? '' : v).trim(); }
function has(o, k) { return !!o && Object.prototype.hasOwnProperty.call(o, k); }

/// 카드 1장 = 차 1대(번호는 trim). exists = 서버 409 CARNO_IN_PROGRESS 가 가리킨 차('진행 중' 배지).
export function newCard(key, carNo) {
  return { key: key, carNo: str(carNo), exists: false };
}

/// 부가서비스 칩 1개 → services 항목 (앱 ExtraServicePicker.selections: reissue 만 kind 동봉, 메모 칸 없음).
export function serviceEntry(option) {
  return option.kind === 'reissue' ? { serviceId: option.id, kind: 'reissue' } : { serviceId: option.id };
}

function carJson(card, ov, exportCancel, broker, visit) {
  var o = { carNo: str(card.carNo) };
  if (has(ov, 'services')) o.services = ov.services;
  if (exportCancel && has(ov, 'buyerName')) o.buyerName = str(ov.buyerName);
  if (broker) {
    var unitId = Number((broker.unitOf || {})[card.key]) || 0;
    var p = (broker.pickupOf || {})[unitId];
    if (unitId > 0) o.unitId = unitId;   // '(본인)' 도 보낸다 — 서버가 본인 몫은 0 으로 저장
    if (!visit && p && (p.kind === 'saved' || p.kind === 'custom')) o.pickupAddress = str(p.address);
  }
  return o;
}

/// 요청 body — 앱 MalsoQuickRequest.toJson 과 키·순서 동일. 첫 키 carNoOnly:true(서버는 === true 만 번호만 경로).
/// common: { cancelType, intakeMethod, urgent, memo, pickupAddress, services[], buyerName }
/// overrides: { [card.key]: { services?, buyerName? } } — 키가 있는 차만 예외.
/// broker(대행사만): { unitOf:{[card.key]:unitId}, pickupOf:{[unitId]:{kind,address}} } — 차마다 unitId, 묶음이 저장 주소·다른 주소면
/// 그 차 pickupAddress(방문 접수는 안 붙인다). 없으면 현행 body 와 같다. 공통 pickupAddress 는 그대로(모아서 수거 차의 주소).
export function buildQuickBody(cards, common, overrides, broker) {
  var exp = common.cancelType !== '폐차말소';
  var visit = common.intakeMethod === '방문';
  var body = { carNoOnly: true, cancelType: common.cancelType, intakeMethod: common.intakeMethod, isUrgent: common.urgent ? 1 : 0, memo: str(common.memo) };
  var pickup = visit ? '' : str(common.pickupAddress);
  if (pickup) body.pickupAddress = pickup;
  body.services = common.services || [];
  if (exp && str(common.buyerName)) body.buyerName = str(common.buyerName);
  body.cars = cards.map(function (c) { return carJson(c, (overrides || {})[c.key], exp, broker, visit); });
  return body;
}

// ── 대행사 거래처 (W1a) — 차마다 거래처를 고르고, 거래처 묶음마다 수거 주소를 고른다 ──

/// 고르기 시트 순서 — 본인 맨 위, 나머지는 최근 신청일 내림차순(빈 값 뒤, 같으면 서버 순서).
export function sortPickClients(clients) {
  return (clients || []).map(function (c, i) { return { c: c, i: i }; }).sort(function (a, b) {
    if (!!a.c.isSelf !== !!b.c.isSelf) return a.c.isSelf ? -1 : 1;
    var da = str(a.c.lastRequestDate), db = str(b.c.lastRequestDate);
    if (da !== db) return !da ? 1 : !db ? -1 : (da < db ? 1 : -1);
    return a.i - b.i;
  }).map(function (x) { return x.c; });
}

/// '최근' 배지 — 본인 외 최근 신청일이 가장 늦은 1곳(같으면 앞), 없으면 0.
export function recentClientId(clients) {
  var best = null;
  (clients || []).forEach(function (c) {
    var d = str(c.lastRequestDate);
    if (!c.isSelf && d && (!best || d > str(best.lastRequestDate))) best = c;
  });
  return best ? best.id : 0;
}

/// 짧은 주소 — 앞 두 마디 ("강원 동해시 해안로 55" → "강원 동해시").
export function shortAddr(addr) { return str(addr).split(/\s+/).slice(0, 2).join(' '); }

/// 묶음 수거 주소 기본값 — 본인 → 모아서 · 저장 주소 있음 → 저장 주소(값 복사) · 그 외 → 모아서.
export function defaultPickup(client) {
  var addr = str(client && client.pickupAddress);
  return client && !client.isSelf && addr ? { kind: 'saved', address: addr } : { kind: 'collect', address: '' };
}

/// 이 차에 고른 거래처 — unitOf 의 id 가 지금 목록에 있을 때만 그 거래처, 아니면 null(미선택).
/// 행 표시·[다음] 잠금·'안 고른 차에도 같이 넣기'가 모두 이 판정을 쓴다(다시 읽은 목록에서 빠진 거래처 = 미선택).
export function pickedClient(clients, unitOf, key) {
  var id = Number((unitOf || {})[key]) || 0;
  return id ? (clients || []).filter(function (c) { return c.id === id; })[0] || null : null;
}

/// 확인 단계 묶음 — [{unitId, client, cards[]}], 본인 묶음 먼저, 나머지는 차 순서상 첫 등장 순. 거래처 없는 카드는 빠진다.
export function groupCards(cards, unitOf, clients) {
  var out = [];
  (cards || []).forEach(function (card) {
    var id = Number((unitOf || {})[card.key]) || 0;
    if (!id) return;
    var g = out.filter(function (x) { return x.unitId === id; })[0];
    if (!g) {
      g = { unitId: id, client: (clients || []).filter(function (c) { return c.id === id; })[0] || { id: id, name: '' }, cards: [] };
      out.push(g);
    }
    g.cards.push(card);
  });
  return out.filter(function (g) { return g.client.isSelf; }).concat(out.filter(function (g) { return !g.client.isSelf; }));
}

/// 신청 게이트 — '다른 주소 입력' 묶음의 주소가 비면 false. 방문 접수는 수거 주소를 쓰지 않으므로 true.
export function brokerPickupReady(groups, pickupOf, intakeMethod) {
  if (intakeMethod === '방문') return true;
  return (groups || []).every(function (g) {
    var p = (pickupOf || {})[g.unitId];
    return !p || p.kind !== 'custom' || !!str(p.address);
  });
}

/// quick 실패 → { key, vars?, existing?, index?, unitIndex? }. 매핑 없는 code 는 null(호출측 describeSimpleError).
/// UNIT_NOT_FOUND 의 unitIndex 는 0부터인 카드 위치 — 화면이 그 거래처를 쓰던 카드의 거래처를 비운다.
/// 서버 부가 필드는 err.body(api.js 정규화) — 화면에는 문구 키·차량번호 목록·차 위치만 넘긴다(body 원문 노출 금지).
/// CARNO_IN_PROGRESS 의 existing 은 0부터인 카드 위치 배열(서버 existing[].index) — 화면은 위치로만 표시한다.
/// FIELD_REQUIRED 의 index 는 0부터인 카드 위치, field 는 그 카드의 칸.
export function mapQuickError(err) {
  var e = err || {};
  var b = e.body || e;
  var index = (Number(b.index) || 0) + 1;
  switch (e.code) {
    case 'AGENCY_NOT_RESOLVED': return { key: 'malsoModeErrAgencyNotResolved' };
    case 'NO_CARS': return { key: 'malsoModeErrNoCars' };
    case 'CARNO_DUPLICATE_IN_REQUEST': return { key: 'malsoModeErrCarNoDuplicate', vars: { carNos: (b.carNos || []).join(', ') } };
    case 'CARNO_IN_PROGRESS': return { key: 'malsoModeErrCarNoInProgress', existing: (b.existing || []).map(function (x) { return Number(x && x.index); }) };
    case 'SERVICE_INVALID': return { key: 'malsoModeErrServiceInvalid', vars: { index: index } };
    case 'FIELD_REQUIRED': return { key: 'malsoModeRequiredMissing', index: index - 1, field: str(b.field) };
    case 'UNIT_NOT_FOUND': return { key: 'malsoModeErrUnitNotFound', vars: { index: index }, unitIndex: index - 1 };
    default: return null;
  }
}
